<script>
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import KavehParsLogo from "@/assets/img/logo/bonyad_logo/kaveh_pars.png";
import FerdosParsLogo from "@/assets/img/logo/bonyad_logo/ferdos_pars.png";
import ParsianLogo from "@/assets/img/logo/bonyad_logo/parsian.png";
import DaneshmandLogo from "@/assets/img/logo/bonyad_logo/daneshmand.png";
import MaliSinaLogo from "@/assets/img/logo/bonyad_logo/mali_sina.jpg";
import AzadrahLogo from "@/assets/img/logo/bonyad_logo/azadrah.png";
import SanayeGhazaeeSinaLogo from "@/assets/img/logo/bonyad_logo/sanaye_ghazaee_sina.jpg";
import PayaSamanParsLogo from "@/assets/img/logo/bonyad_logo/paya_saman_pars.png";
import EnergySinaLogo from "@/assets/img/logo/bonyad_logo/energy_sina.png";
import BarghSinaLogo from "@/assets/img/logo/bonyad_logo/bargh_sina.png";
import BonyadAlaviLogo from "@/assets/img/logo/bonyad_logo/bonyad_alavi.jpg";

export default {
  components: {Sidebar, Splash},
  data() {
    return {
      holdings: [
        {
          title: 'گسترش صنایع معدنی کاوه پارس',
          logo: KavehParsLogo,
          path: '/performance-management/economic-operation-report/holdings/kaveh-pars',
        },
        {
          title: 'کشاورزی و دامداری فردوس پارس',
          logo: FerdosParsLogo,
          path: '',
        },
        {
          title: 'سیاحتی و مراکز تفریحی پارسیان',
          logo: ParsianLogo,
          path: '',
        },
        {
          title: 'تحقیق و توسعه دانشمند',
          logo: DaneshmandLogo,
          path: '',
        },
        {
          title: 'مالی و سرمایه گذاری سینا',
          logo: MaliSinaLogo,
          path: '',
        },
        {
          title: 'آزاد راه تهران شمال',
          logo: AzadrahLogo,
          path: '',
        },
        {
          title: 'صنایع غذایی سینا',
          logo: SanayeGhazaeeSinaLogo,
          path: '',
        },
        {
          title: 'پایا سامان پارس',
          logo: PayaSamanParsLogo,
          path: '',
        },
        {
          title: 'انرژی گستر سینا',
          logo: EnergySinaLogo,
          path: '',
        },
        {
          title: 'برق و انرژی صبا',
          logo: BarghSinaLogo,
          path: '',
        },
        {
          title: 'بنیاد علوی',
          logo: BonyadAlaviLogo,
          path: '',
        },
      ]
    }
  }
}
</script>

<template>
  <Splash/>
  <div class="container mt-4" dir="rtl">
    <sidebar/>
    <div class="card-panel-main col-lg-9 mb-5 p-4">

      <div class="row">
        <div class="col-4 mb-4" v-for="(holding, index) in holdings" :key="index">
          <div class="card bg-white">
            <div class="card-logo">
              <router-link :to="holding.path">
                <img :src="holding.logo" class="card-img-top" alt="logo">
              </router-link>
            </div>
            <div class="card-footer">
              <router-link :to="holding.path">
                {{ holding.title }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card-panel-main {
  transform: translateX(-19vw);
}

a {
  color: dodgerblue;
}

a:hover {
  color: blue;
}

.card-logo {
  height: 17vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5vw;
}

.card-logo a {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-logo img {
  width: 95%;
  min-width: 14vw;
  max-height: 16vw;
  filter: none;
}
</style>
